/* ===========================================================================
   c-compare-tray.js — collection "Compare" checkbox and sticky tray (Step Labs)
   ===========================================================================

   Brief, section 7, entry point 2. Each vacuum card carries a hidden
   "Compare" checkbox (snippets/c-compare-check.liquid). This script reveals
   the ones whose product is enabled and verified, keeps the selection in
   sessionStorage so it survives moving between collection pages, and shows a
   sticky tray that opens /pages/compare with the selected ids.

   Preview: while the compare.* data does not exist no product is eligible, so
   nothing shows on the live store. Add ?compare_preview=1 to a collection URL
   to reveal the checkbox on every vacuum.
   =========================================================================== */
(function () {
  var KEY = 'cCompareTray';
  var MAX = 4;
  var tray = document.querySelector('[data-compare-tray]');
  if (!tray || tray.__cCompareTray) return;
  tray.__cCompareTray = true;

  var preview = /[?&]compare_preview=1/.test(window.location.search);
  var compareUrl = tray.dataset.compareUrl || '/pages/compare?view=c-compare';
  var itemsEl = tray.querySelector('[data-tray-items]');
  var countEl = tray.querySelector('[data-tray-count]');
  var goEl = tray.querySelector('[data-tray-go]');

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { sessionStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode: selection lasts for this page only */ }
  }
  var selected = read();

  function track(name, props) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, props));
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, props);
    } catch (e) { /* tracking must never break the tray */ }
  }

  function render() {
    document.querySelectorAll('[data-compare-check]').forEach(function (label) {
      if (label.dataset.eligible === 'true' || preview) label.hidden = false;
      label.querySelector('input').checked = selected.some(function (item) { return item.id === label.dataset.id; });
    });

    itemsEl.textContent = '';
    selected.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'c-compare-tray__item';
      if (item.img) {
        var img = document.createElement('img');
        img.src = item.img;
        img.alt = item.title;
        li.appendChild(img);
      }
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'c-compare-tray__remove';
      remove.dataset.trayRemove = item.id;
      remove.setAttribute('aria-label', 'Remove ' + item.title + ' from comparison');
      remove.textContent = '\u00d7';
      li.appendChild(remove);
      itemsEl.appendChild(li);
    });

    tray.hidden = selected.length === 0;
    countEl.textContent = selected.length + ' selected';
    var ready = selected.length >= 2;
    goEl.textContent = ready ? 'Compare ' + selected.length + ' of ' + MAX + ' \u2192' : 'Pick one more to compare';
    goEl.setAttribute('aria-disabled', String(!ready));
    goEl.href = compareUrl + (compareUrl.indexOf('?') > -1 ? '&' : '?') + 'ids=' + selected.map(function (item) { return item.id; }).join(',') + '&src=collection';
  }

  document.addEventListener('change', function (event) {
    var label = event.target.closest && event.target.closest('[data-compare-check]');
    if (!label) return;
    var id = label.dataset.id;
    if (event.target.checked) {
      if (selected.length >= MAX) {
        event.target.checked = false;
        countEl.textContent = 'Remove one to add another.';
        tray.hidden = false;
        return;
      }
      selected.push({ id: id, title: label.dataset.title, img: label.dataset.img });
      track('compare_tray_add', { product_id: id, collection: tray.dataset.collection || '' });
    } else {
      selected = selected.filter(function (item) { return item.id !== id; });
    }
    write(selected);
    render();
  });

  tray.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-tray-remove]');
    if (!remove) return;
    selected = selected.filter(function (item) { return item.id !== remove.dataset.trayRemove; });
    write(selected);
    render();
  });

  render();
})();
